module.exports = __webpack_public_path__ + "img/ar_detail.63e02169.png";